var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastRecognition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103.243 87.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M59.749,380.692a5.558,5.558,0,0,0,.069,1.85c.2,1.282,3.306,5.709,2.921,6.815s-2.96,2.832-3.909,2.38c-.592-.281-.115-.744.115-1.673s-1.22-4.3-2.051-5.509l-1.584-2.3Z",
    transform: "translate(-55.31 -380.692)",
    fill: "#ec1a57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M69.56,322.745c-.524,1.713-5.315,7.158-7.3,8.526-.314.216.078,1.328.874,2.485s1.7,1.919,2.009,1.7c1.987-1.368,8.782-3.9,10.57-3.78L72.7,327.171Z",
    transform: "translate(-62.15 -322.745)",
    fill: "#0089c3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M100.613,330.279c-.718.494-2.769-1.239-4.582-3.871s-2.7-5.167-1.982-5.661,2.769,1.239,4.582,3.871S101.331,329.784,100.613,330.279Z",
    transform: "translate(-93.8 -320.663)",
    fill: "#ec1a57"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main-img",
    transform: "translate(-51 -485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(51 485)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y1: 47.014,
    transform: "translate(51.621 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x1: 12.168,
    y1: 45.412,
    transform: "translate(37.839 1.919)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x1: 23.507,
    y1: 40.716,
    transform: "translate(25.191 7.546)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 33.244,
    y1: 33.244,
    transform: "translate(15.246 13.188)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 40.716,
    y1: 23.507,
    transform: "translate(7.546 20.217)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 45.412,
    y1: 12.168,
    transform: "translate(1.919 31.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 47.014,
    transform: "translate(0 43.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 45.412,
    y2: 12.168,
    transform: "translate(1.919 44.034)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x1: 40.716,
    y2: 23.507,
    transform: "translate(7.546 43.775)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 33.244,
    y2: 33.244,
    transform: "translate(15.246 41.067)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x1: 23.507,
    y2: 40.716,
    transform: "translate(25.191 39.239)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 12.168,
    y2: 45.412,
    transform: "translate(37.839 40.169)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y2: 47.014,
    transform: "translate(51.621 40.486)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    x2: 12.168,
    y2: 45.412,
    transform: "translate(53.236 40.169)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    x2: 23.507,
    y2: 40.716,
    transform: "translate(54.544 39.239)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 33.244,
    y2: 33.244,
    transform: "translate(54.752 41.067)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 40.716,
    y2: 23.507,
    transform: "translate(54.981 43.775)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 45.412,
    y2: 12.168,
    transform: "translate(55.911 44.034)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x2: 47.014,
    transform: "translate(56.228 43.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    y1: 12.168,
    x2: 45.412,
    transform: "translate(55.911 31.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    y1: 23.507,
    x2: 40.716,
    transform: "translate(54.981 20.217)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y1: 33.244,
    x2: 33.244,
    transform: "translate(54.752 13.188)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y1: 40.716,
    x2: 23.507,
    transform: "translate(54.544 7.546)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y1: 45.412,
    x2: 12.168,
    transform: "translate(53.236 1.919)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(52.647 489.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M102.492,135.244a25.493,25.493,0,0,0-1.094-9.021,29.541,29.541,0,0,1-1.319-9c.2-3.04,1.563-6.178,4.2-7.7,2.084-1.207,4.629-1.255,6.9-2.06,4-1.42,6.768-5.012,9.793-7.8,5.361-4.947,12.866-6.361,15.821,1.628.911,2.463,1.631,5.189,3.656,6.86,4.024,3.32,9.985,1.19,14.587,1,3.665-.154,7.548.826,10.109,3.452a8.647,8.647,0,0,1,2.419,6.439c-.182,2.867-2.74,4.221-3.166,6.877-.3,1.85.754,3.609,1.513,5.322,3.436,7.752.774,23.327-10.76,16.928-2.048-1.137-4.14-2.706-6.548-2.914-2.96-.256-5.641,1.645-7.89,3.586s-4.563,4.115-7.5,4.59c-4.072.659-7.784-2.121-11.559-3.783a27.079,27.079,0,0,0-16.372-1.364c-2.395.5-4.809,1.27-7.236.964a1.02,1.02,0,0,1-.762-.349,1.084,1.084,0,0,1,.063-.978C99.045,143.718,101.967,139.781,102.492,135.244Z",
    transform: "translate(-84.978 -91.376)",
    fill: "#000200",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M111.339,138.838a24.841,24.841,0,0,0-1.605-8.71,28.8,28.8,0,0,1-1.823-8.68c.012-2.969,1.15-6.1,3.623-7.748,1.955-1.3,4.428-1.5,6.588-2.418,3.808-1.622,6.284-5.282,9.059-8.178,4.919-5.134,12.135-6.96,15.489.635,1.034,2.341,1.9,4.951,3.968,6.455,4.114,2.988,9.785.559,14.251.094,3.556-.37,7.392.351,10.042,2.752a8.428,8.428,0,0,1,2.739,6.119c0,2.8-2.413,4.272-2.667,6.881-.177,1.818.95,3.465,1.792,5.087,3.808,7.336,2.152,22.647-9.453,17.114-2.061-.983-4.189-2.384-6.545-2.442-2.895-.072-5.389,1.939-7.461,3.962s-4.192,4.277-7.017,4.915c-3.922.885-7.7-1.6-11.472-2.987a26.4,26.4,0,0,0-16.01-.345c-2.3.632-4.6,1.525-6.982,1.373a.993.993,0,0,1-.762-.294,1.057,1.057,0,0,1,0-.955C108.494,147.29,111.1,143.284,111.339,138.838Z",
    transform: "translate(-92.578 -93.724)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M109.948,147.394a12.309,12.309,0,0,0-.194-9.044c-1.047-2.484-2.5-4.523-1.94-7.335,1.182-5.936,7.47-5.876,11.142-9.461,3.893-3.8,5.511-8.371,11.858-7.762a14.6,14.6,0,0,1,9.5,4.906c1.75,2.012,3.542,4.321,6.295,4.908,3.369.719,7.076-.115,10.494.031,3.259.139,6.766.882,9.366,2.955a8.091,8.091,0,0,1,2.944,8.606c-.556,2.013-1.856,3.7-2.215,5.762-.672,3.86,1.744,7.538,1.48,11.428a8.12,8.12,0,0,1-8.363,7.4c-4.127-.3-8.712-3.521-12.589-.64-2.1,1.557-3.263,3.978-5.731,5.135-3.1,1.456-6.3.1-9.168-1.252a18.916,18.916,0,0,0-10.847-1.271,44.352,44.352,0,0,0-10.547,3.3,26.945,26.945,0,0,1-7.36,2.383,3.128,3.128,0,0,1-1.673-.159c-1.266-.592-1.389-2.35-1.083-3.714.631-2.81,2.315-5.026,3.846-7.377A40.425,40.425,0,0,0,109.948,147.394Z",
    transform: "translate(-88.076 -105.448)",
    fill: "#fec832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M117.253,151.77a11.689,11.689,0,0,0-.184-8.587c-.994-2.359-2.374-4.294-1.842-6.964,1.123-5.636,7.093-5.579,10.579-8.983,3.7-3.609,5.233-7.948,11.258-7.37a13.864,13.864,0,0,1,9.023,4.658c1.662,1.911,3.363,4.1,5.976,4.66,3.2.682,6.718-.109,9.963.03,3.094.132,6.424.837,8.893,2.805a7.682,7.682,0,0,1,2.8,8.171c-.527,1.911-1.762,3.513-2.1,5.471-.638,3.665,1.656,7.157,1.405,10.851a7.71,7.71,0,0,1-7.941,7.022c-3.919-.283-8.271-3.342-11.952-.608-1.99,1.478-3.1,3.777-5.441,4.876-2.947,1.382-5.984.092-8.7-1.189a17.962,17.962,0,0,0-10.3-1.207,42.128,42.128,0,0,0-10.014,3.134,25.576,25.576,0,0,1-6.987,2.263,2.969,2.969,0,0,1-1.589-.151c-1.2-.562-1.319-2.232-1.028-3.526.6-2.668,2.2-4.772,3.651-7A38.4,38.4,0,0,0,117.253,151.77Z",
    transform: "translate(-94.093 -110.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M186.247,232.587l40.419,2.054.807,12.794-40.728-1.207Z",
    transform: "translate(-154.13 -197.734)",
    fill: "#000200",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M159.406,170.134l46.533-4.387,1.168,12.826-46.458,4.278Z",
    transform: "translate(-133.288 -145.833)",
    fill: "#000200",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M190.948,236.916h37.265l1.34,11.727-37.509.793Z",
    transform: "translate(-157.78 -201.096)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M168.358,176.682,211.31,174l.7,11.838-42.88,2.583Z",
    transform: "translate(-140.239 -152.242)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(0 44.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(0 7.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(2.852 15.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M59.749,380.692a5.558,5.558,0,0,0,.069,1.85c.2,1.282,3.306,5.709,2.921,6.815s-2.96,2.832-3.909,2.38c-.592-.281-.115-.744.115-1.673s-1.22-4.3-2.051-5.509l-1.584-2.3Z",
    transform: "translate(-55.31 -380.692)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M48.864,377.557a6.733,6.733,0,0,1,2.869-.8,10.241,10.241,0,0,1,2.221.117l-1.072-4.582-6.672,3.8Z",
    transform: "translate(-48.244 -374.169)",
    fill: "#231f20",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M45.228,379.423c-.387.267-1.259-.328-1.948-1.327s-.932-2.026-.545-2.293,1.259.327,1.947,1.327S45.616,379.157,45.228,379.423Z",
    transform: "translate(-42.552 -361.189)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M46.682,376.993c-.387.267-1.39-.517-2.239-1.75s-1.224-2.45-.837-2.716,1.39.517,2.239,1.751S47.069,376.726,46.682,376.993Z",
    transform: "translate(-43.252 -358.653)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M47.213,366.283l4.282-2.426-3.564-5.175-3.794,3.135Z",
    transform: "translate(-43.783 -347.943)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M64.212,363.7c-.387.267-1.5-.675-2.483-2.1s-1.468-2.8-1.081-3.071,1.5.675,2.483,2.1S64.6,363.434,64.212,363.7Z",
    transform: "translate(-56.5 -347.786)",
    fill: "#bf201f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(4.38 2.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M69.56,322.745c-.524,1.713-5.315,7.158-7.3,8.526-.314.216.078,1.328.874,2.485s1.7,1.919,2.009,1.7c1.987-1.368,8.782-3.9,10.57-3.78L72.7,327.171Z",
    transform: "translate(-62.15 -322.745)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M87.032,330.037a2.406,2.406,0,0,1-.53.429,23.266,23.266,0,0,1-3.252,1.722,9.495,9.495,0,0,1-3.578.774,2.658,2.658,0,0,1-.993-.151,1.181,1.181,0,0,1-.7-.686.227.227,0,0,1-.009-.153.259.259,0,0,1,.1-.107c.8-.543,1.609-1.072,2.377-1.658a6.628,6.628,0,0,0,1.945-1.97,3.689,3.689,0,0,0,.058-3.014,26.436,26.436,0,0,1-1.282-3.966c-.127-.733-.411-2.406.488-2.82,1.048-.483,3.09,1.714,4.561,4.907a14.123,14.123,0,0,1,1.343,4.491A2.7,2.7,0,0,1,87.032,330.037Z",
    transform: "translate(-74.428 -319.349)",
    fill: "#000200",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M88.233,338.408c.293-.343.579-.687.852-1.025",
    transform: "translate(-78.023 -331.405)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M67.588,349.455A23.725,23.725,0,0,0,71.4,345.74",
    transform: "translate(-61.992 -337.894)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 2.429,
    cy: 6.937,
    rx: 2.429,
    ry: 6.937,
    transform: "translate(9.051 2.755) rotate(-34.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(11.455 2.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M100.613,330.279c-.718.494-2.769-1.239-4.582-3.871s-2.7-5.167-1.982-5.661,2.769,1.239,4.582,3.871S101.331,329.784,100.613,330.279Z",
    transform: "translate(-93.8 -320.663)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0.183 3.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M94.619,337.671l2.462-1.063.886,1.286L95.8,339.386Z",
    transform: "translate(-94.619 -336.584)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M101.083,345.569l1.872-1.921-.886-1.286L99.9,343.855Z",
    transform: "translate(-98.721 -341.052)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M104.85,345.622l-1.872,1.921-.635-.923,2.013-1.717Z",
    transform: "translate(-100.617 -343.026)",
    fill: "#000200",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M107.162,339.1c-.2.137-.755-.329-1.245-1.039s-.725-1.4-.527-1.533.755.329,1.245,1.039S107.361,338.961,107.162,339.1Z",
    transform: "translate(-102.929 -336.501)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 2.669,
    y2: 1.926,
    transform: "translate(1.115 12.54)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 6.7,
    y2: 0.39,
    transform: "translate(21.25 17.674)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y1: 3.806,
    x2: 5.528,
    transform: "translate(20.243 6.047)",
    fill: "none",
    stroke: "#fec832",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 6.271,
    x2: 2.391,
    transform: "translate(14.572 0.976)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M131.881,323.346l6.285-3.86.918,2.057,4.927-1.367-5.487,4.15-1.192-2.2Z",
    transform: "translate(-111.915 -309.591)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M123.207,287.712l3.868-3.651-1.26-1.025,1.877-3.174-3.921,3.042,1.311,1.244Z",
    transform: "translate(-105.18 -278.822)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M152.549,278.864l1.495-3.651,1.806,1.467Z",
    transform: "translate(-127.963 -275.213)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M171.358,339.741l2.309-1.017.18,1.477Z",
    transform: "translate(-142.568 -324.529)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M175.15,294.941l1.528-2.007.872,1.205Z",
    transform: "translate(-145.513 -288.973)",
    fill: "#0089c3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(3.458 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M392.232,135.868l.185,1.487a.312.312,0,0,0,.166.239l1.33.69a.312.312,0,0,1-.011.56l-1.357.636a.312.312,0,0,0-.176.232l-.245,1.478a.312.312,0,0,1-.536.162l-1.024-1.094a.312.312,0,0,0-.274-.1l-1.482.223a.312.312,0,0,1-.32-.46l.724-1.312a.312.312,0,0,0,.006-.291l-.67-1.34a.312.312,0,0,1,.338-.446l1.471.283a.312.312,0,0,0,.278-.084l1.067-1.052A.312.312,0,0,1,392.232,135.868Z",
    transform: "translate(-314.594 -122.42)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M307.016,343.069l.755,1.294a.313.313,0,0,0,.247.154l1.494.111a.312.312,0,0,1,.21.519l-1,1.118a.313.313,0,0,0-.07.282l.356,1.456a.312.312,0,0,1-.429.36l-1.372-.6a.312.312,0,0,0-.29.02l-1.274.788a.312.312,0,0,1-.475-.3l.149-1.491a.312.312,0,0,0-.109-.269l-1.143-.968A.312.312,0,0,1,304.2,345l1.464-.319a.313.313,0,0,0,.223-.187l.567-1.387A.312.312,0,0,1,307.016,343.069Z",
    transform: "translate(-248.988 -283.402)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M148.293,115.449l.879.721a.237.237,0,0,0,.216.044l1.092-.315a.237.237,0,0,1,.286.314l-.415,1.059a.238.238,0,0,0,.024.219l.637.941a.237.237,0,0,1-.21.369l-1.135-.067a.237.237,0,0,0-.2.091l-.7.9a.237.237,0,0,1-.416-.086l-.287-1.1a.237.237,0,0,0-.148-.163l-1.069-.388a.237.237,0,0,1-.047-.422l.958-.613a.237.237,0,0,0,.109-.192l.038-1.136A.237.237,0,0,1,148.293,115.449Z",
    transform: "translate(-126.872 -106.736)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M313.114,110.4l.487,1.027a.238.238,0,0,0,.176.133l1.122.181a.237.237,0,0,1,.125.406l-.827.781a.238.238,0,0,0-.072.209l.175,1.123a.237.237,0,0,1-.348.244l-1-.545a.237.237,0,0,0-.221,0l-1.014.513a.237.237,0,0,1-.34-.255l.21-1.117a.236.236,0,0,0-.065-.211l-.8-.806a.237.237,0,0,1,.138-.4l1.127-.146a.236.236,0,0,0,.18-.127l.519-1.011A.237.237,0,0,1,313.114,110.4Z",
    transform: "translate(-254.189 -102.752)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M182.116,376.205l1.006.53a.236.236,0,0,0,.22,0l1.007-.528a.237.237,0,0,1,.343.25l-.194,1.12a.237.237,0,0,0,.068.21l.813.794a.237.237,0,0,1-.132.4l-1.125.162a.237.237,0,0,0-.179.129l-.5,1.019a.237.237,0,0,1-.425,0l-.5-1.02a.237.237,0,0,0-.178-.13l-1.125-.165a.237.237,0,0,1-.131-.4l.815-.792a.237.237,0,0,0,.068-.21l-.191-1.121A.237.237,0,0,1,182.116,376.205Z",
    transform: "translate(-153.518 -309.23)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M426.077,201.334l.652.931a.237.237,0,0,0,.2.1l1.137-.01a.237.237,0,0,1,.191.38l-.684.908a.237.237,0,0,0-.036.218l.361,1.078a.237.237,0,0,1-.3.3l-1.075-.37a.237.237,0,0,0-.218.034l-.914.676a.237.237,0,0,1-.378-.194l.019-1.137a.237.237,0,0,0-.1-.2l-.925-.66a.237.237,0,0,1,.068-.419l1.087-.333a.237.237,0,0,0,.157-.155l.342-1.084A.237.237,0,0,1,426.077,201.334Z",
    transform: "translate(-342.125 -173.388)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M114.08,95.1l.882.717a.237.237,0,0,0,.216.044l1.091-.319a.237.237,0,0,1,.288.313l-.41,1.06a.237.237,0,0,0,.025.219l.641.939a.237.237,0,0,1-.209.37l-1.135-.062a.237.237,0,0,0-.2.092l-.695.9a.237.237,0,0,1-.416-.084l-.292-1.1a.237.237,0,0,0-.149-.162l-1.07-.383a.237.237,0,0,1-.049-.422l.955-.617a.236.236,0,0,0,.108-.192l.033-1.136A.237.237,0,0,1,114.08,95.1Z",
    transform: "translate(-100.315 -90.938)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M84.018,224.379l-.2.768a.166.166,0,0,0,.034.15l.517.6a.165.165,0,0,1-.116.273l-.793.044a.165.165,0,0,0-.132.079l-.413.678a.165.165,0,0,1-.3-.026l-.287-.74a.165.165,0,0,0-.116-.1l-.773-.184a.165.165,0,0,1-.066-.289l.616-.5a.165.165,0,0,0,.06-.142l-.064-.791a.166.166,0,0,1,.255-.152l.667.43a.166.166,0,0,0,.154.014l.733-.306A.166.166,0,0,1,84.018,224.379Z",
    transform: "translate(-76.107 -191.08)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M447.315,258.756l-.711.353a.165.165,0,0,0-.09.125l-.112.786a.165.165,0,0,1-.282.093l-.556-.567a.165.165,0,0,0-.147-.047l-.782.136a.166.166,0,0,1-.175-.24l.368-.7a.165.165,0,0,0,0-.154l-.371-.7a.165.165,0,0,1,.174-.24l.783.132a.165.165,0,0,0,.146-.048l.553-.57a.165.165,0,0,1,.283.091l.116.786a.166.166,0,0,0,.091.124l.713.35A.165.165,0,0,1,447.315,258.756Z",
    transform: "translate(-358.068 -216.736)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M269.354,81.772l-.649.458a.165.165,0,0,0-.07.137l.01.794a.165.165,0,0,1-.264.135l-.636-.475a.165.165,0,0,0-.152-.024l-.752.255a.165.165,0,0,1-.21-.21l.255-.752a.165.165,0,0,0-.024-.152l-.474-.637a.165.165,0,0,1,.135-.264l.794.011a.166.166,0,0,0,.137-.07l.459-.648a.166.166,0,0,1,.293.047l.235.758a.165.165,0,0,0,.109.109l.758.236A.166.166,0,0,1,269.354,81.772Z",
    transform: "translate(-219.789 -79.453)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M208.034,345.088l.217,1.116a.238.238,0,0,0,.138.172l1.042.454a.237.237,0,0,1,.02.424l-.994.551a.237.237,0,0,0-.121.184l-.11,1.131a.237.237,0,0,1-.4.15L207,348.5a.236.236,0,0,0-.213-.058l-1.11.245a.237.237,0,0,1-.266-.331l.48-1.03a.237.237,0,0,0-.01-.22l-.576-.98a.237.237,0,0,1,.233-.355l1.128.139a.237.237,0,0,0,.206-.078l.754-.851A.237.237,0,0,1,208.034,345.088Z",
    transform: "translate(-172.358 -284.94)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M352.637,90.424,352.274,84l3.691.892Z",
    transform: "translate(-286.505 -82.355)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M357.673,113.109l4.362-4.735,1.929,3.271Z",
    transform: "translate(-290.698 -101.284)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M349.059,338.993l5.885,2.61-2.478,2.877Z",
    transform: "translate(-284.009 -280.357)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M417.5,241.97l3.813,1.77-1.65,1.851Z",
    transform: "translate(-337.155 -205.02)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M338.905,370.406l1.994,3.7-2.429.495Z",
    transform: "translate(-275.787 -304.749)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M113.088,136.06l-4.159-.613,1.056-2.243Z",
    transform: "translate(-97.551 -120.564)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 1.151,
    cy: 1.151,
    rx: 1.151,
    ry: 1.151,
    transform: "translate(3.649 18.372)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 0.576,
    cy: 0.576,
    rx: 0.576,
    ry: 0.576,
    transform: "translate(7.179 10.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 0.576,
    cy: 0.576,
    rx: 0.576,
    ry: 0.576,
    transform: "translate(81.861 44.582)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M368.164,393.2a.576.576,0,1,1-.576-.576A.576.576,0,0,1,368.164,393.2Z",
    transform: "translate(-297.949 -321.999)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 0.576,
    cy: 0.576,
    rx: 0.576,
    ry: 0.576,
    transform: "translate(57.892 2.96)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M59.172,239.97a.576.576,0,1,1-.576-.576A.576.576,0,0,1,59.172,239.97Z",
    transform: "translate(-58.021 -203.02)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M264.588,379.594a.576.576,0,1,1-.576-.576A.576.576,0,0,1,264.588,379.594Z",
    transform: "translate(-217.523 -311.436)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 1.151,
    cy: 1.151,
    rx: 1.151,
    ry: 1.151,
    transform: "translate(74.768 61.645)",
    fill: "#ec1a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M429.151,121.282A1.151,1.151,0,1,1,428,120.13,1.151,1.151,0,0,1,429.151,121.282Z",
    transform: "translate(-344.411 -110.412)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.151,
    cy: 1.151,
    rx: 1.151,
    ry: 1.151,
    transform: "translate(37.931 65.855)",
    fill: "#0089c3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 1.641,
    cy: 1.641,
    rx: 1.641,
    ry: 1.641,
    transform: "translate(24.538)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 1.641,
    cy: 1.641,
    rx: 1.641,
    ry: 1.641,
    transform: "translate(3.649 42.081)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 1.641,
    cy: 1.641,
    rx: 1.641,
    ry: 1.641,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 55.34, 77.147)",
    fill: "#a8cf45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 1.641,
    cy: 1.641,
    rx: 1.641,
    ry: 1.641,
    transform: "translate(83.098 53.143)",
    fill: "#a8cf45"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ANNOUNCE",
    transform: "translate(97.85 519.499) rotate(-3)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15,
    y: 0
  }, "ANNOUNCE")), /*#__PURE__*/React.createElement("text", {
    id: "CELEBRATE",
    transform: "translate(98.65 530.886) rotate(-1)",
    fill: "#fff",
    fontSize: 3,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "CELEBRATE")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "&",
    transform: "translate(125.698 523.836) rotate(-3)",
    fill: "#ec1a57",
    fontSize: 4,
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1,
    y: 0
  }, "&amp;")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastRecognition);
export default __webpack_public_path__ + "static/media/last-recognition.16a3e005a0066fca5a81e89fb5ab98ed.svg";
export { ForwardRef as ReactComponent };